export const isMonetateGroup = (
  features?: Partial<Features>,
  experienceName?: string,
  splitValue = 'Experiment'
): boolean => {
  const experiences = features?.monetateExperiences || [];
  return experiences.some(exp => {
    const experience = exp.experienceName || exp.key;
    const split = exp.variantLabel || exp.split;
    return (
      experience &&
      experienceName &&
      experience.indexOf(experienceName) > -1 &&
      split &&
      (split === splitValue || split.includes(splitValue))
    );
  });
};
